'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _utils = require('../utils');

function defaultValueFormatter(value, state) {
  var _getProps = (0, _utils.getProps)(state),
      unit = _getProps.unit,
      precision = _getProps.precision,
      fixedNum = _getProps.fixedNum,
      delimiter = _getProps.delimiter;

  var _precision = Number.parseInt(fixedNum || precision, 10) || 0;
  if ((0, _lodash.isNil)(unit) || (0, _lodash.isNil)(value) || value === '') {
    return value;
  } else {
    return '' + Number(value).toLocaleString('en-US', { minimumFractionDigits: _precision, useGrouping: !!delimiter }) + (unit || '');
  }
}

exports.default = {
  defaultValueFormatter: defaultValueFormatter
};
module.exports = exports['default'];